module.exports = __webpack_public_path__ + "img/background31.f543edbd.jpg";